import React, { Component } from 'react';
import track from 'react-tracking';
import { connect } from 'react-redux';
import { LayoutChat } from 'layouts';
import { COMPONENT_TYPE, PATH } from 'shared/constants';
import {
  submitReply, clearConversationHistory, updateSummary, updateStep,
} from 'shared/redux/actions';
import iconClose from 'assets/icons/iconTopbarClose.png';
import { ButtonList, RiskPopup, CarouselOption } from 'components';
import { getRTL } from 'shared/redux/selectors';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import RiskPicker from './RiskPicker';

import { trackRiskProfilingOption, trackRiskProfile } from './RiskAssessment.tracking';
import { eventRiskAssesmentRiskProfile, eventRiskAssesmentNotSure } from 'components/TrackEvent/constEvent';
import trackEvent from 'components/TrackEvent/TrackEvent';

class RiskAssessment extends Component {
   closeInvestorProfile = () => {
     const {
       history,
     } = this.props;
     history.push(PATH.JOURNEY_OVERVIEW);
   };

   //  onFinish = () => {
   //    const { onUpdateSummary, messageOptions } = this.props;
   //    if (messageOptions) {
   //      const { riskAttitude, timeFrame } = messageOptions.risk_score ? JSON.parse(_.unescape(messageOptions.risk_score)) : {};
   //      onUpdateSummary({ 'summary.risk': messageOptions.risk });
   //      onUpdateSummary({ 'summary.riskScore': timeFrame });
   //      onUpdateSummary({ 'summary.riskAttitude': riskAttitude });
   //    }
   //  };
  handleRestart = () => {
    const { onClearConversationHistory, onReplySubmit } = this.props;
    onClearConversationHistory().then(() => onReplySubmit('restart'));
  };

  onPopupShow = () => {
    const { onUpdateSummary, messageOptions, summary } = this.props;
    if (messageOptions) {
      const { riskAttitude, timeFrame } = messageOptions.risk_score ? JSON.parse(_.unescape(messageOptions.risk_score)) : {};
      onUpdateSummary({
        'summary.risk': messageOptions.risk,
        'summary.riskScore': timeFrame,
        'summary.riskAttitude': riskAttitude,
        'summary.risk_description': summary['summary.allRisks'].find(item => item.preRiskProfileCode === messageOptions.risk).preRiskProfileDescription,
      });
    }
  };

  render() {
    const {
      conversations,
      inputComponent,
      onUpdateSummary,
      inputOptions,
      onReplySubmit,
      messageOptions,
      tracking,
      summary,
      isRtl,
      intl,
      currentThread,
      currentLocale,
    } = this.props;

    let input;

    switch (inputComponent) {
      case COMPONENT_TYPE.RISK_ASSESSMENT:
        input = (
          <RiskPicker
            rtl={isRtl}
            onSubmit={(reply) => {
              onReplySubmit(reply);
              if (reply !== 'not_sure') {
                onUpdateSummary({ 'summary.risk': reply });
                trackEvent(eventRiskAssesmentRiskProfile(currentLocale, reply));
              } else {
                trackEvent(eventRiskAssesmentNotSure(currentLocale, 'not_sure'));
              }
              /** track risk profiling option */
              trackRiskProfilingOption(tracking, reply);
              /** */
            }}
            optionList={inputOptions}
          />
        );
        break;
      case COMPONENT_TYPE.PLAN_WITHDRAW:
        input = (
          <ButtonList
            optionList={inputOptions}
            onOptionClick={reply => onReplySubmit(reply)}
            isOptionButton
            rtl={isRtl}
          />
        );
        break;
      case COMPONENT_TYPE.RISK_QUESTION:
        let currentInput;
        if (currentThread === 'markaz.gain_and_lost_scenario.ask') {
          currentInput = (
            <CarouselOption
              optionList={inputOptions}
              onOptionClick={reply => onReplySubmit(reply)}
              isStatGraphOption
              rtl={isRtl}
            />
          );
        } else if (currentThread === 'markaz.desired_investment_portfolio.ask') {
          currentInput = (
            <CarouselOption
              optionList={inputOptions}
              onOptionClick={reply => onReplySubmit(reply)}
              isInvestmentPortfolio
              rtl={isRtl}
            />
          );
        } else {
          currentInput = (
            <ButtonList
              optionList={inputOptions}
              onOptionClick={reply => onReplySubmit(reply)}
              isOptionButton
              rtl={isRtl}
            />
          );
        }
        input = currentInput;
        break;
      case COMPONENT_TYPE.RISK_POPUP:
        if (messageOptions && messageOptions.risk) {
          // console.log(messageOptions);
          const { riskAttitude, timeFrame } = messageOptions.risk_score ? JSON.parse(_.unescape(messageOptions.risk_score)) : {};
          if (messageOptions.risk !== summary['summary.risk'] || !summary['summary.risk']) {
            onUpdateSummary({ 'summary.risk': messageOptions.risk });
          }
          if (timeFrame && (timeFrame !== summary['summary.riskScore'] || !summary['summary.riskScore'])) {
            onUpdateSummary({ 'summary.riskScore': timeFrame });
          }
          if (riskAttitude && (riskAttitude !== summary['summary.riskAttitude'] || !summary['summary.riskAttitude'])) {
            onUpdateSummary({ 'summary.riskAttitude': riskAttitude });
          }
        }
        input = (
          <RiskPopup
            optionList={inputOptions}
            profile={messageOptions && messageOptions.risk}
            isRedoQuiz={messageOptions && messageOptions.redo_quiz}
            onOptionClick={(reply) => {
              onReplySubmit(reply);
              /** track risk profile */
              trackRiskProfile(tracking, summary['summary.risk']);
              /** */
            }}
            rtl={isRtl}
            onShow={this.onPopupShow}
          />
        );
        break;
      default:
        input = '';
    }

    return (
      <LayoutChat
        conversations={conversations}
        input={input}
        navTitle="risk.title"
        subTitle={intl.formatMessage({ id: 'journey.step' }, { number: 2 })}
        leftButton={<FontAwesomeIcon icon={faRedo} />}
        onLeftClick={this.handleRestart}
        rightButton={<img src={iconClose} alt="X" />}
        onRightClick={this.closeInvestorProfile}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => ({
  conversations: state.rootReducer.riskAssessment,
  inputComponent: state.rootReducer.inputComponent,
  currentThread: state.rootReducer.currentThread,
  inputOptions: state.rootReducer.inputOptions,
  messageOptions: state.rootReducer.messageOptions,
  summary: state.rootReducer.summary,
  isRtl: getRTL(state.rootReducer),
  currentLocale: state.rootReducer.language.locale,
});

const mapDispatchToProps = ({
  onReplySubmit: submitReply,
  onClearConversationHistory: clearConversationHistory,
  onUpdateSummary: updateSummary,
  onUpdateStep: updateStep,
});

export default track({
  page: 'RiskAssessment',
})(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(RiskAssessment)));
